import { ActionIcon, Avatar, Button, Center, Group, Loader, Modal, Select } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconDownload } from '@tabler/icons-react';
import React, { useState, useRef } from 'react';
import { saveAs } from 'file-saver';
import html2canvas from 'html2canvas';
import useCreate from '../create/useCreate';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

// Enable dayjs plugins
dayjs.extend(utc);
dayjs.extend(timezone);

function ActionCell({ row }) {
    const [opened, { open, close }] = useDisclosure(false);
    const [selectedTheme, setSelectedTheme] = useState(null);
    const [bannerImage, setBannerImage] = useState(null);
    const bannerRef = useRef(null); // Reference to the banner container

    const {
        ThemeQuery11: { data, isPending, isError, isRefetching },
    } = useCreate();



    // Handle theme selection
    const handleThemeSelect = (theme) => {
        console.log('Selected theme image URL:', theme);
        setSelectedTheme(theme);
        setBannerImage(theme); // Assuming theme is the image URL
    };


    // Handle banner download
    const handleDownloadBanner = async () => {
        if (!bannerImage || !bannerRef.current) {
            console.error('Banner image or container not ready');
            return;
        }

        try {

            // Wait for the DOM to render with updated data
            setTimeout(async () => {
                const bannerElement = bannerRef.current;
                if (bannerElement) {

                    const canvas = await html2canvas(bannerElement, {
                        useCORS: true, // Enable CORS for cross-origin images
                        allowTaint: true, // Allow tainted canvas (for testing, use carefully)
                        logging: true, // Enable logging for debugging
                        backgroundColor: null, // Preserve transparency
                        scale: 10, // Increase resolution
                    });
                    canvas.toBlob((blob) => {
                        saveAs(blob, 'banner.png');
                    });
                } else {
                    console.error('Banner element not found');
                }
                close(); // Close the modal after download
            }, 500); // Delay to ensure rendering
        } catch (error) {
            console.error('Error downloading banner:', error);
        }
    };

    return (
        <Group gap="sm">
            <ActionIcon size="sm" onClick={open}>
                <IconDownload size={14} />
            </ActionIcon>
            <Modal opened={opened} onClose={close} centered title="Download Banner">
                <Select
                    label="Select Theme"
                    placeholder="Pick one"
                    searchable
                    data={data ?? []}
                    onChange={handleThemeSelect}
                    nothingFound={isPending ? <Loader size="xs" /> : 'No items found'}
                    clearable
                />

                {/* Banner Preview */}
                {selectedTheme && bannerImage && row && (
                    <div
                        className='preview_area'
                        ref={bannerRef}
                        style={{
                            width: '300px',
                            height: '500px',
                            position: 'relative',
                            margin: '20px auto',
                            color: 'white',
                            fontFamily: 'Arial, sans-serif',

                        }}
                    >
                        {/* Use an <img> tag for the background instead of CSS background-image */}
                        <img
                            src={bannerImage}
                            alt="Background"
                            style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                                zIndex: 1,
                            }}

                        />

                        {/* Overlay content on top of the background */}
                        <div
                            style={{
                                position: 'relative',
                                zIndex: 2,
                                width: '100%',
                                height: '100%',
                            }}
                        >
                            {/* Usernames */}
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    padding: '10px',
                                }}
                            >
                                <div style={{ textAlign: 'center' }}>
                                    <Avatar
                                        size={30}
                                        src={row?.user?.image?.url}
                                        radius={50}
                                        style={{
                                            width: '100px',
                                            height: '100px',
                                            background: '#ccc',
                                            borderRadius: '50%',
                                            margin: '0 auto',
                                        }}
                                    />
                                    <div
                                        style={{
                                            paddingTop: 3,
                                            paddingBottom: 3,
                                            backgroundColor: 'rgba(14, 33, 40, 0.75)',
                                            paddingLeft: 10,
                                            paddingRight: 10,
                                            borderRadius: 10,
                                            marginTop: 17,
                                            marginRight: 10,
                                            maxWidth: 100,
                                            overflowWrap: "break-word",
                                            wordWrap: "break-word",

                                        }}
                                    >
                                        <p
                                            style={{
                                                fontSize: 16,
                                                textAlign: 'center',
                                                margin: 0,
                                                whiteSpace: 'nowrap',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                            }}
                                        >
                                            {row?.user?.tiktok_username}
                                        </p>
                                    </div>
                                </div>
                                <div style={{ textAlign: 'center' }}>
                                    <Avatar
                                        size={30}
                                        src={row?.opponent?.image?.url}

                                        radius={50}
                                        style={{
                                            width: '100px',
                                            height: '100px',
                                            background: '#ccc',
                                            borderRadius: '50%',
                                            margin: '0 auto',
                                        }}
                                    />
                                    <div
                                        style={{
                                            paddingTop: 3,
                                            paddingBottom: 3,
                                            backgroundColor: 'rgba(14, 33, 40, 0.75)',
                                            paddingLeft: 10,
                                            paddingRight: 10,
                                            borderRadius: 10,
                                            marginTop: 17,
                                            marginRight: 10,
                                            maxWidth: 100,
                                            overflowWrap: "break-word",
                                            wordWrap: "break-word",

                                        }}
                                    >
                                        <p
                                            style={{
                                                fontSize: 16,
                                                textAlign: 'center',
                                                margin: 0,
                                                whiteSpace: 'nowrap',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                            }}
                                        >
                                            {row?.opponent?.tiktok_username}
                                        </p>
                                    </div>
                                </div>
                            </div>

                            {/* Time */}
                            <div
                                style={{

                                    position: 'absolute',
                                    bottom: 30,
                                    left: 0,
                                    right: 0,
                                    margin: '0 auto',
                                    paddingTop: 5,
                                    paddingBottom: 5,
                                    paddingLeft: 20,
                                    paddingRight: 20,
                                    borderRadius: 7,
                                    textAlign: 'center',
                                    width: 'fit-content',
                                }}
                            >
                                <Avatar
                                    size={30}
                                    src={row?.agency?.image}
                                    radius={50}
                                    style={{
                                        width: '100px',
                                        height: '100px',
                                        background: '#ccc',
                                        borderRadius: '50%',
                                        margin: '0 auto',

                                    }}
                                />
                                <p
                                    style={{
                                        backgroundColor: 'rgba(14, 33, 40, 0.75)',
                                        fontSize: 40,
                                        fontWeight: 'bold', // Make text bold
                                        textAlign: 'center',
                                        margin: 0,
                                        fontFamily: 'Arial, sans-serif',
                                        whiteSpace: 'nowrap',
                                    }}
                                >
                                    {dayjs.utc(row.match_confirm_time).local().format('DD.MM - HH:mm')}
                                </p>
                            </div>
                        </div>
                    </div>
                )}

                <Center mt="md">
                    <Button onClick={handleDownloadBanner} disabled={!selectedTheme}>
                        Download Banner
                    </Button>
                </Center>
            </Modal>
        </Group>
    );
}

export default ActionCell;
